<style>
  .hiddenButton {
      display: none;
  }
</style>
<form [formGroup] = "form">
  <h1 *ngIf ="mode ==1" mat-dialog-title> Editing {{data.customer_name}} - {{data.job_type_name}}</h1>
  <h1 *ngIf ="mode ==2" mat-dialog-title> <div><p>Add New Customer Job</p> </div>  </h1>

  <div mat-dialog-content>

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <span style="color: black;">Basic</span>
        </ng-template>
    <mat-form-field style="width:90%">
      <mat-label>Customer: {{data.customer_name}}</mat-label>
      <input  #custname matInput [placeholder]="(this.data.customer_name || '')" formControlName = "customer_name" [matAutocomplete] = "custauto" (input)="customerInputHandler()">
     </mat-form-field>

    <!-- we need to not show the autocomplete when not in use-->
    <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)" [displayWith]="displayFunction">
      <mat-option *ngFor="let cust of (customer$ | async)" [value]="cust">
        <span>{{ cust.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <mat-form-field style="width:90%">
      <mat-label>Job Type: {{data.job_type_name}}</mat-label>
      <input  #jtname matInput [placeholder]="(this.data.job_type_name || '')" formControlName = "job_type_name" [matAutocomplete] = "jtauto" (input)="jobInputHandler()">
     </mat-form-field>

     <div *ngIf = 'showtext.length > 0'>
     <span *ngIf="isDuplicate"><p style="color:red;">{{showtext}}</p></span>
     <span *ngIf="!isDuplicate"><p style="color:lightgreen;">{{showtext}}</p></span>
    </div>
    <!-- we need to not show the autocomplete when not in use-->
    <mat-autocomplete #jtauto = "matAutocomplete" (optionSelected) = "onSelectJobType($event.option.value)" [displayWith]="displayFunction">
      <mat-option *ngFor="let jt of (jobtype$ | async)" [value]="jt">
        <span>{{ jt.job_type}}</span>
      </mat-option>
    </mat-autocomplete>

    <div *ngIf="showRe" style="border:1px solid lightgrey;
    margin-bottom: 30px;
    padding: 9px;"><mat-label>Create 'Re-' Job? </mat-label>
      <mat-checkbox formControlName = "createRe" (change)="toggleCreateRe()"></mat-checkbox></div>



    <mat-form-field style="width:80%">
      <mat-label>Note: </mat-label>
      <textarea matInput formControlName = "note"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Billing Note: </mat-label>
      <textarea matInput formControlName = "billingnote"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Test Specs: </mat-label>
      <textarea matInput formControlName = "testspecs"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Envelope Specs: </mat-label>
      <textarea matInput formControlName = "envspecs"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>HVAC Grading Instructions: </mat-label>
      <textarea matInput formControlName = "hvacspecs"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Sticker Placement Info: </mat-label>
      <textarea matInput formControlName = "stickerplacement"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Subdivision: {{subdivisionDisplay}} </mat-label>
      <input type="text"  #subname matInput formControlName= "subdivision" [matAutocomplete] = "subdivisionAuto" >
    </mat-form-field> 
    <button (click)= "clearOut('subdivision')" class='radioClearButton' *ngIf="form.get('subdivision').value > 1"> Clear</button>


  <mat-autocomplete #subdivisionAuto = "matAutocomplete" (optionSelected) = "onSelectSubdivision($event.option.value)" [displayWith]="displayFunction">
      <mat-option *ngFor="let subdivision of (subdivision$ | async)" [value]="subdivision">
        <span>{{ subdivision.subdivision_name}}</span>
      </mat-option>
    </mat-autocomplete>



    <mat-form-field style="width:80%">
      <mat-label>Required: </mat-label>
      <textarea matInput formControlName="required"></textarea>
    </mat-form-field>

    <P>Will the invoice be: </P>
    <div style="    display: flex;
    justify-content: space-evenly;
    border: 1px solid darkgrey;
    margin: 5px;
    padding: 12px;
    position: relative;
    bottom: 10px;">
    <mat-label>Emailed?:  </mat-label>
    <mat-checkbox formControlName = "invoicetobeemailed"></mat-checkbox>

    <mat-label>Printed?:  </mat-label>
    <mat-checkbox formControlName = "invoicetobeprinted"></mat-checkbox>

    <mat-label>Billable?:  </mat-label>
    <mat-checkbox formControlName = "billable"></mat-checkbox>
    </div>



    <mat-form-field style="width:80%">
      <mat-label>Report Email Distribution: </mat-label>
      <textarea matInput formControlName="repemaildist"></textarea>
    </mat-form-field>

    <button *ngIf="mode == 1 && form.get('repemaildist').dirty && form.get('job_type_name').value.toLowerCase().includes('qi')" style="margin-bottom: 2em;" (click)="updateOtherQIs()" title="This will update other QI jobs for this customer with the values in the list">Update other QI jobs</button>

    <mat-form-field style="width:80%">
      <mat-label>QI Reports sent from: </mat-label>
      <textarea matInput formControlName="qirepfrom"></textarea>
    </mat-form-field>


    <mat-form-field style="width:90%">
        <mat-label>Price:</mat-label>
        <input matInput formControlName = "price">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>Flat Adder:</mat-label>
        <input matInput formControlName = "flatadder">
      </mat-form-field>

      <mat-form-field>
        <mat-label> Rate </mat-label>
        <mat-select  formControlName = "rate">
          <mat-option *ngFor = "let item of rates" [value] = "item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-label>Inactive?:  </mat-label>
      <mat-checkbox formControlName = "inactivecustomerjob"></mat-checkbox>

      <mat-form-field style="width:90%">
        <mat-label>Alias:</mat-label>
        <input #jtAlias matInput formControlName = "alias">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>Estimated Time:</mat-label>
        <input matInput type="number" formControlName = "estimatedtime" (input)="checkEstimatedTime()">
      </mat-form-field>
      <p style="color: red;" *ngIf="(!form.get('estimatedtime').value || form.get('estimatedtime').value == 0) && site_visit_required">Site visit job - Estimated time needed!</p>

      </mat-tab>


      <mat-tab>
        <ng-template mat-tab-label>
          <span style="color: black;">Tags</span>
        </ng-template>

        <!-- The chip input control -->
        <div style="display: flex;
        width: 90%;
        height: 200px;
        margin-top: 30px;
        align-content: flex-start;
        flex-wrap: wrap;
        justify-content: space-evenly;">
        <mat-form-field style="width:85%;">
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let tag of inputTags" [selectable]="true" [removable]="true" (removed)="removeTag(tag)">
              {{tag.displayname}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="Add tag..."
                   [matAutocomplete]="auto"
                   [matChipInputFor]="chipList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                   (matChipInputTokenEnd)="addTag($event)"
                   (keyup.enter)="onEnter(auto)"
                   formControlName="tagControl">
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event, $event.option.value)">
            <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
              {{tag.displayname}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

        <!-- MF / SF / GPS tag-type filter. None ticked = show all. -->
        <div style="display:flex; gap:1em; margin-bottom:0.5em; align-items:center;">
          <span style="color:#757575; font-size:0.9em;">Show:</span>
          <mat-checkbox *ngFor="let t of tagService.TAG_TYPES"
                        [checked]="tagTypeFilter.includes(t)"
                        (change)="toggleTagType(t)">{{t}}</mat-checkbox>
        </div>

        <div style="height: 200px;">
        <mat-chip-list>
          <mat-chip *ngFor="let tag of visibleTags" (click)="addTag($event, tag)" matTooltip="{{tag.description}}">{{tag.displayname}}</mat-chip>
        </mat-chip-list>

      </div>


      </mat-tab>


    </mat-tab-group>

    <br>

  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
    <button *ngIf ="mode ==1" mat-button  (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    <button id="addbutton" *ngIf ="mode ==2" mat-button  (click)="add()"  cdkFocusInitial>Add</button>
  </div>
  </form>
